import { useEffect, useState } from "react";

import { LoadingPage } from "@hl/base-components/lib/LoadingPage";
import { Box, Text, Modal, Divider, Button, Space } from "@mantine/core";

import SeriesMetadataTablePreview from "~/features/collections/forms/CreateCollectionMultistepForm/SeriesMetadataTablePreview";
import { SeriesToken } from "~/features/collections/forms/CreateCollectionMultistepForm/context";

import { GetManageTokenCollectionQuery } from "../../queries.graphql.generated";

export const ViewSeriesMetadataModal = ({
  seriesTokens,
  isAuction,
  onClose,
}: ViewSeriesMetadataModalProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [tokens, setTokens] = useState<SeriesToken[]>([]);

  useEffect(() => {
    setLoading(true);
    const tokens = seriesTokens?.edges.map((token) => {
      const attributes = token.attributes.reduce(
        (all, attribute) => ({
          ...all,
          ...{ [attribute.name]: attribute.value },
        }),
        {}
      );
      return {
        ...attributes,
        imageUrl: token.imageUrl,
      };
    });

    setTokens(tokens ?? []);
    setLoading(false);
  }, []);

  return (
    <Modal
      opened
      title={
        <Text weight={500} size="lg">
          {isAuction ? "Auction metadata" : "Collection metadata"}
        </Text>
      }
      onClose={onClose}
      size="xl"
    >
      <Box mx="auto">
        {loading ? (
          <LoadingPage marginTop={30} marginBottom={40} />
        ) : (
          <SeriesMetadataTablePreview tokens={tokens} />
        )}
      </Box>
      <Space h={8} />
      <Divider mx={-16} />
      <Button mt="md" fullWidth size="xl" onClick={onClose}>
        Done
      </Button>
    </Modal>
  );
};

export interface ViewSeriesMetadataModalProps {
  seriesTokens: GetManageTokenCollectionQuery["getCollection"]["seriesTokens"];
  isAuction: boolean;
  onClose: () => void;
}
